import axios from 'axios';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

const clean = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''),
);

// Module Inventaires — sessions de comptage (/api/inventaires ; le singulier
// /api/inventaire est l'héritage menus/permissions, rien à voir).
export const getInventaireConfig = () => axios.get(`${DOMAIN}/api/inventaires/config`);
export const getInventaires = () => axios.get(`${DOMAIN}/api/inventaires`);
export const createInventaire = (body) => axios.post(`${DOMAIN}/api/inventaires`, body);
export const getInventaire = (id) => axios.get(`${DOMAIN}/api/inventaires/${id}`);
export const getInventaireLignes = (id, params = {}) =>
  axios.get(`${DOMAIN}/api/inventaires/${id}/lignes`, { params: clean(params) });
export const saveInventaireLigne = (id, idLigne, body) =>
  axios.put(`${DOMAIN}/api/inventaires/${id}/lignes/${idLigne}`, body);
export const validerInventaire = (id) => axios.post(`${DOMAIN}/api/inventaires/${id}/valider`);
export const abandonnerInventaire = (id, motif) =>
  axios.post(`${DOMAIN}/api/inventaires/${id}/abandonner`, { motif });

// --- Équipes et progression ---------------------------------------------------
// Le journal de comptage est additif : la progression se lit en gestes et en
// paires vues, jamais en écart (comptage à l'aveugle).
export const getProgression = (id) => axios.get(`${DOMAIN}/api/inventaires/${id}/progression`);
export const getAffectations = (id) => axios.get(`${DOMAIN}/api/inventaires/${id}/affectations`);
// Concordance : les articles vus par plusieurs passes. Par défaut, uniquement
// ceux où les passes ne disent pas la même chose — les autres n'appellent rien.
export const getConcordance = (id, tous = false) =>
  axios.get(`${DOMAIN}/api/inventaires/${id}/concordance`, { params: tous ? { tous: 1 } : {} });
export const affecterCompteur = (id, body) =>
  axios.post(`${DOMAIN}/api/inventaires/${id}/affectations`, body);
// La passe fait partie de la clé : le même compteur peut être sur le comptage
// ET sur le recomptage, ce sont deux affectations distinctes.
export const retirerCompteur = (id, idUser, passe) =>
  axios.delete(`${DOMAIN}/api/inventaires/${id}/affectations/${idUser}`, { params: { passe } });

// Annuaire complet (rôles inclus) : réservé à l'admin, comme l'affectation.
export const getUtilisateurs = () => axios.get(`${DOMAIN}/api/user/getUser`);

// --- Clôture ------------------------------------------------------------------
// Le tri des écarts par CAUSE : un total brut ne dit rien tant qu'on n'a pas
// séparé « jamais compté » de « compté à zéro », ni les écarts explicables par
// une vente survenue pendant l'inventaire.
export const getCloture = (id) => axios.get(`${DOMAIN}/api/inventaires/${id}/cloture`);
export const getMouvementsFenetre = (id) => axios.get(`${DOMAIN}/api/inventaires/${id}/mouvements`);
// Enregistre un comptage de ZÉRO sur les références jamais comptées : tracé,
// annulable, et soumis à la même justification que n'importe quel écart.
export const marquerAbsents = (id, body) =>
  axios.post(`${DOMAIN}/api/inventaires/${id}/cloture/absents`, body);

// Tableau de bord TEMPS RÉEL du comptage (admin). Le serveur renvoie des
// « il y a N secondes », jamais des horodatages à comparer à l'horloge du
// poste : un poste mal réglé afficherait n'importe quoi.
export const getTempsReel = (id) => axios.get(`${DOMAIN}/api/inventaires/${id}/temps-reel`);
